<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">
    Failed to activate license.<br>
    {{ error?.description }}
  </div>
</div>
<div class="notice notice-error" *ngIf="contract.product == 'PROTECT_FOR_VMS'">
  <div class="notice-body">Unsupported operation. Protect host tokens can only be obtained from a Cristie Appliance.
  </div>
</div>
<div class="notice notice-error" *ngIf="contract.product == 'SYSBACK'">
  <div class="notice-body">Unsupported operation. Sorry, this isn't available yet. Please contact <a
      href="mailto:support@cristie.com?subject=SysBack%20License%20Required&body=Hello Cristie Support,%0A%0AI%20require%20a%20SysBack%20license.%0AThank%20you">support&#64;cristie.com</a>
    to obtain a SysBack license.</div>
</div>
<div class="notice notice-error" *ngIf="checkCombination()">
  <div class="notice-body">You do not have enough available activations. Please purchase more activations or choose a
    different combination.</div>
</div>
<div class="notice notice-error" *ngIf="isInvalidPlatformCombination()">
  <div class="notice-body">AIX is only available for physical server activations.</div>
</div>

<section *ngIf="contract.product != 'PROTECT_FOR_VMS' && contract.product != 'SYSBACK'">
  <mat-card *ngIf="isSiteLicensed(); else standardActivationCard" class="activate-summary-card site-license-card">
    <mat-card-header>
      <mat-card-title>Site License</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div *ngIf="siteActivation; else siteLicensePending">
        <p class="site-license-text">
          Your site license key is valid until {{ siteLicenseExpiry | date: "dd MMMM yyyy" }}.
        </p>
        <pre class="site-license-key-block"><code id="site-license-key">{{ siteActivation.code }}</code></pre>
        <div class="notice notice-warning">
          <div class="notice-body">Site licenses are subject to random licensing audits and should not be abused.</div>
        </div>
        <div class="site-license-actions">
          <button mat-stroked-button color="primary" type="button" id="copy-site-license-key" (click)="copySiteLicenseKey()">
            Copy Key
          </button>
          <button mat-stroked-button color="primary" type="button" id="copy-site-license-windows" (click)="copySiteLicenseCommand('Windows')">
            Copy Windows licensing command
          </button>
          <button mat-stroked-button color="primary" type="button" id="copy-site-license-linux" (click)="copySiteLicenseCommand('Linux')">
            Copy Linux licensing command
          </button>
          <button mat-stroked-button color="primary" type="button" id="copy-site-license-solaris" (click)="copySiteLicenseCommand('Solaris')">
            Copy Solaris licensing command
          </button>
          <button mat-stroked-button color="primary" type="button" id="copy-site-license-aix" (click)="copySiteLicenseCommand('AIX')">
            Copy AIX licensing command
          </button>
        </div>
      </div>
      <ng-template #siteLicensePending>
        <div class="notice notice-error">
          <div class="notice-body">This contract is site licensed, but no site license key has been generated yet. Please contact support.</div>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>

  <ng-template #standardActivationCard>
  <mat-card class="activate-summary-card">
    <mat-card-header>
      <mat-card-title>Available Activations</mat-card-title>
    </mat-card-header>
    <mat-card-content class="activate-summary-grid">
      <div>
        <strong>Physical Server</strong><br>
        <span id="activate-physical-available">{{ contract.activations?.available }}</span>
      </div>
      <div>
        <strong>Virtual Server</strong><br>
        <span id="activate-virtual-available">{{ contract.vmActivations?.available }}</span>
      </div>
      <div>
        <strong>Desktop</strong><br>
        <span id="activate-desktop-available">{{ contract.desktopActivations?.available }}</span>
      </div>
    </mat-card-content>
  </mat-card>
  </ng-template>

  <mat-tab-group *ngIf="!isSiteLicensed() && contract.rental; else activateFormOnly" id="activate-tab-group" [mat-stretch-tabs]="false"
    [selectedIndex]="active - 1" (selectedIndexChange)="active = $event + 1">
    <mat-tab label="New Activation">
      <ng-template matTabContent>
        <ng-container *ngTemplateOutlet="activateFormTemplate"></ng-container>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="contract.rental" label="Renew Activations ({{expired.length}})">
      <app-activation-details [activations]="expired" [showSurrender]="false" [showRenew]="true" [contractId]="contract.id"
        [product]="contract.product" [rental]="contract.rental"></app-activation-details>
    </mat-tab>
  </mat-tab-group>
</section>

<ng-template #activateFormOnly>
  <ng-container *ngIf="!isSiteLicensed()">
    <ng-container *ngTemplateOutlet="activateFormTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #activateFormTemplate>
  <mat-card class="activate-form-card">
    <mat-card-content class="activate-form-content">
      <form [formGroup]="ActivateLicenseForm" class="material-form-grid">
        <mat-form-field appearance="fill" class="activate-top-field">
          <mat-label>Machine Type</mat-label>
          <mat-select formControlName="machineType" (selectionChange)="onMachineTypeChange()">
            <mat-option value="Select">Select</mat-option>
            <mat-option value="Physical">Physical</mat-option>
            <mat-option value="Virtual">Virtual</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="activate-top-field">
          <mat-label>Activation Type</mat-label>
          <mat-select formControlName="type2" (selectionChange)="onMachineTypeChange()">
            <mat-option value="Select">Select</mat-option>
            <mat-option value="Server">Server</mat-option>
            <mat-option [disabled]="!canSelectActivationType('Desktop')" value="Desktop">Desktop</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="activate-top-field">
          <mat-label>Platform</mat-label>
          <mat-select formControlName="osType">
            <mat-option value="Select">Select</mat-option>
            <mat-option value="Windows">Windows</mat-option>
            <mat-option value="Linux">Linux</mat-option>
            <mat-option value="Solaris">Solaris</mat-option>
            <mat-option [disabled]="f.machineType.value == 'Virtual' || f.type2.value == 'Desktop'" value="AIX">AIX</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="activate-ip-field">
          <mat-label>IP Address</mat-label>
          <input matInput type="text" id="ipaddress" formControlName="ipAddress" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="activate-hostname-field">
          <mat-label>Hostname</mat-label>
          <input matInput type="text" id="hostname" formControlName="hostName" />
        </mat-form-field>

        <div class="activate-checkbox-row">
          <mat-checkbox id="secureSite" formControlName="secureSite" (change)="checkChange()">Secure site</mat-checkbox>
        </div>

        <div class="activate-signature-field">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Signature</mat-label>
            <input matInput type="text" id="signature" placeholder="xxxxxxxx-xxxxxxxx-xxxxxxxx-xxxxxxxx" formControlName="signature" />
            <mat-hint align="start" *ngIf="isSiteLicensed()">Signature validation is skipped for site licensed contracts</mat-hint>
            <mat-hint align="start" *ngIf="!isSiteLicensed() && !f.secureSite.value">{{sigHelp}}</mat-hint>
            <mat-hint align="start" *ngIf="!isSiteLicensed() && f.secureSite.value">Signature validation is skipped for secure
              sites</mat-hint>
            <mat-hint align="end" [ngClass]="signatureCountClass">{{ signatureLength }}/35</mat-hint>
          </mat-form-field>
        </div>

        <div class="form-actions full-width">
          <button mat-flat-button color="primary" type="submit" id="activate-license-button" (click)="activateLicense()"
            [disabled]="activateDisabled()">
            <mat-spinner *ngIf="activating" diameter="20" mode="indeterminate"></mat-spinner>
            {{ activating ? 'Activating' : 'Activate License' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #activationModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="activate-dialog-title" class="dialog-title">
      <span class="title-text">Activation Successful</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="activate-modal-dismiss-button"
        (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>
      <div class="notice">
        <div class="notice-body">Successfully activated license.</div>
      </div>

      <table class="table table-sm table-bordered modal-result-table">
        <thead>
          <tr>
            <th>Hostname</th>
            <th>Activation Key</th>
            <th>Licensing Command</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of activationResponse;">
            <td class="modal-hostname-cell">{{ entry.hostname }}</td>
            <td><code class="modal-key-cell">{{ entry.code }}</code></td>
            <td>
              <div class="license-command-cell">
                <code>{{ getLicenseCommand(entry) }}</code>
                <button mat-icon-button color="primary" type="button" (click)="copyLicenseCommand(entry)" matTooltip="Copy license command">
                  <mat-icon>terminal</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="accent" type="button" id="activate-copy-details-button" (click)="copyActivationDetails()">Copy
        Details</button>
      <button mat-raised-button color="primary" type="button" id="activate-modal-close-button" (click)="closeDialog()">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
